module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CartInfoDropDownContent":{"button":"Přejít do košíku","heading":"V košíku máte","deliveryDate":"Dodání","days":"{count} dní | {count} den | {count} dny | {count} dní","totalPrice":"Cena celkem: {totalPrice}"}},"en":{"CartInfoDropDownContent":{"button":"Go to cart","heading":"You have in your cart","deliveryDate":"Delivery","totalPrice":"Total price"}}}')
  delete Component.options._Ctor
}
